export type TutorScope = {
  studentId: string;
  subjectId: string;
  status: string;
  activeFrom: string;
  activeUntil: string | null;
};

export type ParentScope = {
  studentId: string;
  canViewProgress: boolean;
};

export function isTutorAssignmentActive(
  scope: Pick<TutorScope, 'status' | 'activeFrom' | 'activeUntil'>,
  onDate: string,
) {
  if (scope.status !== 'active') return false;
  if (scope.activeFrom > onDate) return false;
  if (scope.activeUntil && scope.activeUntil < onDate) return false;
  return true;
}

export function assertTutorSubjectScope(
  scopes: TutorScope[],
  studentId: string,
  subjectId: string,
  onDate: string,
) {
  const allowed = scopes.some(
    (scope) =>
      scope.studentId === studentId
      && scope.subjectId === subjectId
      && isTutorAssignmentActive(scope, onDate),
  );
  if (!allowed) {
    throw new Error('Tutor tidak memiliki akses aktif untuk murid dan mata pelajaran ini.');
  }
}

export function assertParentProgressScope(scopes: ParentScope[], studentId: string) {
  const scope = scopes.find((item) => item.studentId === studentId);
  if (!scope) {
    throw new Error('Belum ada anak yang terhubung ke akun ini.');
  }
  if (!scope.canViewProgress) {
    throw new Error('Akses perkembangan anak belum diaktifkan.');
  }
}
